import React from 'react';
import Input from '../../PencilEditor/Input';
import './OfferTaxModal.scss';

export interface ColoradoTaxConfigsProps {
  collectCityTaxInPayment: boolean;
  collectCountyTaxInPayment: boolean;
  collectCityTaxInPaymentHandler: (value: boolean | undefined) => void;
  collectCountyTaxInPaymentHandler: (value: boolean | undefined) => void;
}

/**
 * Colorado Tax Configurations
 *
 * @constructor
 */
export default function ColoradoTaxConfigs(props: ColoradoTaxConfigsProps) {
  const {
    collectCityTaxInPayment,
    collectCountyTaxInPayment,
    collectCityTaxInPaymentHandler,
    collectCountyTaxInPaymentHandler,
  } = props;

  return (
    <div className="taxConfigurationContainer">
      <div className="taxConfigurationEntry">
        <Input
          type="checkbox"
          key="collectCityTaxInPayment"
          checked={collectCityTaxInPayment}
          onChange={collectCityTaxInPaymentHandler}
          required
        />
        <span className="taxConfigurationLabel">
          Collect City Tax in Payment
        </span>
      </div>
      <div className="taxConfigurationEntry">
        <Input
          type="checkbox"
          key="collectCountyTaxInPayment"
          checked={collectCountyTaxInPayment}
          onChange={collectCountyTaxInPaymentHandler}
          required
        />
        <span className="taxConfigurationLabel">
          Collect County Tax in Payment
        </span>
      </div>
    </div>
  );
}
